import universal from 'react-universal-component';

export default universal(() => import('./TeamsLanding'));



// WEBPACK FOOTER //
// ./src/app/views/TeamsLanding/index.js